(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cv-creative-editor"] && !Shopify.designMode) return;
  try {
    window.addEventListener('message', event => {
    if (event.origin !== 'https://headless-zwdifywdbub-criscioneantonio30-1412.wix-site-host.com') return;
    const frame = [...document.querySelectorAll('[data-cv-editor-frame]')].find(element => element.contentWindow === event.source);
    if (!frame) return;
    if (['CV_CART_SUBMIT','CV_CART_READY'].includes(event.data?.type)) {
      try {
        const cart = new URL(event.data.cartUrl);
        const packs = Number(cart.searchParams.get('quantity'));
        if (!['https://cartavivastudio.com','https://3e07cr-wj.myshopify.com'].includes(cart.origin) || !['/cart/add','/en/cart/add'].includes(cart.pathname) || cart.searchParams.get('id') !== frame.dataset.cvEditorVariant || !Number.isInteger(packs) || packs < 1 || packs > 50) return;
        const section=frame.closest('.cv-inline-editor');
        section.querySelector('[data-cv-cart-handoff]')?.remove();
        const form=document.createElement('form');
        form.dataset.cvCartHandoff='true';form.method='post';form.action='https://cartavivastudio.com'+cart.pathname;
        const preview=Boolean(window.Shopify?.designMode);
        form.target=preview?'_blank':'_self';form.rel='noopener';
        const fields=['id','quantity','properties[Personalization ID]','properties[_cv_design_url]','properties[_cv_receipt]','properties[Modello]'];
        for(const name of fields){const value=cart.searchParams.get(name);if(value!==null){const input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;form.append(input);}}
        const destination=document.createElement('input');destination.type='hidden';destination.name='return_to';destination.value=cart.pathname.startsWith('/en/')?'/en/cart':'/cart';form.append(destination);
        if(preview){
          const note=document.createElement('p');note.textContent=section.dataset.cvPreviewNote;form.append(note);
          const button=document.createElement('button');button.type='submit';button.className='button';button.textContent=section.dataset.cvCartLabel;form.append(button);
          section.append(form);form.scrollIntoView({block:'center',behavior:'smooth'});button.focus({preventScroll:true});
          frame.contentWindow.postMessage({type:'CV_CART_PREVIEW_READY'},event.origin);
        }else{
          form.hidden=true;section.append(form);frame.contentWindow.postMessage({type:'CV_CART_ACCEPTED'},event.origin);HTMLFormElement.prototype.submit.call(form);
        }
      } catch {}
      return;
    }
    const height = event.data?.height;
    if (event.data?.type !== 'CV_EDITOR_HEIGHT' || !Number.isFinite(height) || height < 400 || height > 12000) return;
    frame.style.height = Math.ceil(height) + 'px';
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cv-language"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown',function(event){if(event.key!=='Escape')return;document.querySelectorAll('.cv-locale[open]').forEach(function(menu){menu.open=false;menu.querySelector('summary').focus()})});
document.addEventListener('click',function(event){document.querySelectorAll('.cv-locale[open]').forEach(function(menu){if(!menu.contains(event.target))menu.open=false})});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cv-print-buy"] && !Shopify.designMode) return;
  try {
    function initializePrintOrders(root = document) {
    root.querySelectorAll('[data-cv-print-order]').forEach(order => {
      if (order.dataset.ready) return;
      order.dataset.ready = 'true';
      const quantity = order.querySelector('[name="quantity"]');
      const variant = order.querySelector('[data-cv-variant]');
      const formatter = new Intl.NumberFormat(order.dataset.locale, {style:'currency', currency:order.dataset.currency});
      const submit = order.querySelector('[name="add"]');
      const apps = order.querySelector('.cv-product-apps');
      function syncDesignState() {
        const personalize = apps.querySelector('.cv-personalize-button');
        const ready = personalize && personalize.textContent.includes('Remove design');
        const available = variant.tagName === 'SELECT' ? variant.selectedOptions[0].dataset.available === 'true' : submit.dataset.available === 'true';
        submit.disabled = !ready || !available || !quantity.checkValidity();
        order.querySelector('[data-cv-personalize-required]').hidden = Boolean(ready);
      }
      new MutationObserver(syncDesignState).observe(apps, {childList:true, subtree:true, characterData:true, attributes:true});
      order.querySelector('form').addEventListener('submit', event => {syncDesignState(); if (submit.disabled) {event.preventDefault(); apps.querySelector('button')?.focus();}});
      function update() {
        const chosen = variant.tagName === 'SELECT' ? variant.selectedOptions[0] : variant;
        const price = Number(chosen.dataset.price) / 100;
        const packs = Number(quantity.value);
        const valid = Number.isInteger(packs) && packs >= 1 && packs <= 50;
        order.querySelector('[data-cv-copy-count]').textContent = valid ? packs * 7 : '—';
        order.querySelector('[data-cv-print-total]').textContent = valid ? formatter.format(packs * price) : '—';
        order.querySelector('[data-cv-unit-price]').textContent = formatter.format(price);
        order.querySelectorAll('[data-cv-packs]').forEach(button => button.setAttribute('aria-pressed', String(valid && Number(button.dataset.cvPacks) === packs)));
      }
      quantity.addEventListener('input', () => {update(); syncDesignState();});
      variant.addEventListener('change', update);
      variant.addEventListener('change', syncDesignState);
      order.querySelectorAll('[data-cv-packs]').forEach(button => button.addEventListener('click', () => {quantity.value = button.dataset.cvPacks; quantity.dispatchEvent(new Event('input', {bubbles:true}));}));
      update();
      syncDesignState();
    });
  }
  initializePrintOrders();
  document.addEventListener('shopify:section:load', event => initializePrintOrders(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cv-text-planner"] && !Shopify.designMode) return;
  try {
    function initializeTextPlanners(root = document) {
    root.querySelectorAll('[data-cv-text-planner]').forEach(planner => {
      if (planner.dataset.ready) return;
      planner.dataset.ready = 'true';
      const fields = Object.fromEntries([...planner.querySelectorAll('[data-cv-text]')].map(field => [field.dataset.cvText, field]));
      const outputs = {names: planner.querySelector('[data-cv-result="names"]'), event: planner.querySelector('[data-cv-result="event"]')};
      const limits = {names:40, event:180};
      const singleLine = value => value.replace(/\s+/g, ' ').trim();
      function update() {
        outputs.names.value = [singleLine(fields.nameOne.value), singleLine(fields.nameTwo.value)].filter(Boolean).join(' & ');
        let date = '';
        if (fields.date.value) date = new Intl.DateTimeFormat(planner.dataset.locale, {day:'numeric', month:'long', year:'numeric'}).format(new Date(fields.date.value + 'T12:00:00'));
        const when = [date, fields.time.value].filter(Boolean).join(' · ');
        outputs.event.value = [fields.heading.value, when, fields.venue.value, fields.message.value, fields.rsvp.value].map(singleLine).filter(Boolean).join(' · ');
        let tooLong = false;
        Object.entries(outputs).forEach(([key, output]) => {
          const count = planner.querySelector(`[data-cv-count="${key}"]`);
          const over = output.value.length > limits[key];
          count.textContent = `${output.value.length} / ${limits[key]}`;
          count.classList.toggle('is-over', over);
          planner.querySelector(`[data-cv-copy="${key}"]`).disabled = over || !output.value.trim();
          tooLong ||= over;
        });
        planner.querySelector('[data-cv-text-limit]').hidden = !tooLong;
        planner.querySelector('[data-cv-copy-status]').textContent = '';
      }
      Object.values(fields).forEach(field => field.addEventListener('input', update));
      planner.querySelectorAll('[data-cv-copy]').forEach(button => button.addEventListener('click', async () => {
        const output = outputs[button.dataset.cvCopy];
        try {
          await navigator.clipboard.writeText(output.value);
          planner.querySelector('[data-cv-copy-status]').textContent = planner.dataset.copied;
        } catch {
          output.focus();
          output.select();
          planner.querySelector('[data-cv-copy-status]').textContent = planner.dataset.copyError;
        }
      }));
      update();
    });
  }
  initializeTextPlanners();
  document.addEventListener('shopify:section:load', event => initializeTextPlanners(event.target));
  } catch(e) { console.error(e); }
})();

})();
